import {AssetType} from '$share/types/common'

import type {Asset} from '$share/types/asset'
import type {FieldRequired} from '$share/types/common'

export const EfinCategory = {
    POINT: {
        name: '포인트∙머니',
        order: 1,
    },
    CARD: {
        name: '카드포인트',
        order: 2,
    },
    SHOPPING: {
        name: '쇼핑∙배달',
        order: 3,
    },
    TRANS: {
        name: '교통∙지역화폐',
        order: 4,
    },
    ETC: {
        name: '기타',
        order: 5,
    },
}

export type EfinCategoryKeys = keyof typeof EfinCategory

interface MdPrepaid {
    regDate: string
    limitAmt: number
    isCharge: boolean
    isWithdrawable: boolean
    currencyCode: string | null
}

export interface PrepaidAsset extends FieldRequired<Asset, 'category'> {
    mdPrepaid: MdPrepaid
}

interface Method {
    payOrgCode: string
    payType: string
    payId: string
    primary: boolean
}

interface MdPaid {
    regDate: string
    pay: boolean // 결제수단 등록 여부
    methods: Method[] // 결제수단 정보
}

export interface PaidAsset extends FieldRequired<Asset, 'category'> {
    mdPaid: MdPaid
}

export type EfinAsset = PrepaidAsset | PaidAsset

export function isPrepaidAsset(asset: EfinAsset): asset is PrepaidAsset {
    return asset.assetType === AssetType.PREPAID
}
export function isPaidAsset(asset: EfinAsset): asset is PaidAsset {
    return asset.assetType === AssetType.PAID
}
